import { useState, useRef } from "react";
import { Box, IconButton, Button } from "@chakra-ui/react";
import { FiLogOut } from "react-icons/fi";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import AlertDialogModel from "./AlertModel/AlertDialogModel";
import { UserAuth } from "../Supabase/context/AuthContext";
import { useNavigate } from "react-router-dom";

const LogoutButton = () => {
  const { session, signOut } = UserAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);


  const handleSignOut = async (e) => {
    e.preventDefault();

    try {
      await signOut();
      navigate("/");
    } catch (err) {
      setError("An unexpected error occurred.");
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const cancelRef = useRef();

  const onClose = () => setIsOpen(false);

  // const handleLogout = () => {
  //   onClose();
  //   logout();
  // };

  const propData = {
    title: "Confirm Logout",
    description: "Are you sure you want to logout?",
    btnName: "Logout",
    isOpen: isOpen,
    onClose: onClose,
    handleForAction: handleSignOut,
  };

  return (
    <>
      <Box w="95%" m={"auto"} display="flex" justifyContent="flex-end">
        <IconButton
          aria-label="Logout"
          icon={<FiLogOut fontSize="12px" />}
          w="16px"
          h="16px"
          colorScheme="transparent"
          onClick={() => setIsOpen(true)}
          _hover={{
            // bg: "red.100", 
            color: "red.400", 
          }}
        />
      </Box>
      <AlertDialogModel {...propData} />
    </>
  );
};

export default LogoutButton;
